import { render } from "./ClinicianMentionHint.vue?vue&type=template&id=53154e06&scoped=true"
import script from "./ClinicianMentionHint.vue?vue&type=script&lang=js"
export * from "./ClinicianMentionHint.vue?vue&type=script&lang=js"

import "./ClinicianMentionHint.vue?vue&type=style&index=0&id=53154e06&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53154e06"]])

export default __exports__